import type { FC } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

import ControlledInput from "widgets/common/ControlledInput"

type RangeConditionType = "above" | "below" | "inside" | "outside"

interface RangeInputProps {
  rangeCondition: RangeConditionType
  index?: number
  unit?: string
}

const RangeInput: FC<RangeInputProps> = ({ rangeCondition, index, unit }) => {
  const { t } = useTranslation()

  const getInputs = (rangeCondition: RangeConditionType) => {
    switch (rangeCondition) {
      case "above":
        return (
          <ControlledInput
            placeholder=""
            variant="outlined"
            type="number"
            name={`thresholds.${index}.above`}
            rules={{ required: true }}
            endAdornment={unit}
            size="small"
          />
        )
      case "below":
        return (
          <ControlledInput
            placeholder=""
            variant="outlined"
            type="number"
            name={`thresholds.${index}.below`}
            rules={{ required: true }}
            endAdornment={unit}
            size="small"
          />
        )
      case "inside":
        return (
          <Stack
            sx={{
              flexDirection: "row",
              gap: 1.25,
              alignItems: "center",
              width: "100%",
            }}
          >
            <ControlledInput
              placeholder=""
              variant="outlined"
              type="number"
              name={`thresholds.${index}.inside.from`}
              rules={{ required: true }}
              endAdornment={unit}
              size="small"
            />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {t("alert_settings.TO")}
              </Typography>
            </Box>
            <ControlledInput
              placeholder=""
              variant="outlined"
              type="number"
              name={`thresholds.${index}.inside.to`}
              rules={{ required: true }}
              endAdornment={unit}
              size="small"
            />
          </Stack>
        )
      case "outside":
        return (
          <Stack
            sx={{
              flexDirection: "row",
              gap: 1.25,
              alignItems: "center",
              width: "100%",
            }}
          >
            <ControlledInput
              placeholder=""
              variant="outlined"
              type="number"
              name={`thresholds.${index}.outside.from`}
              rules={{ required: true }}
              endAdornment={unit}
              size="small"
            />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {t("alert_settings.TO")}
              </Typography>
            </Box>
            <ControlledInput
              placeholder=""
              variant="outlined"
              type="number"
              name={`thresholds.${index}.outside.to`}
              rules={{ required: true }}
              endAdornment={unit}
              size="small"
            />
          </Stack>
        )
    }
  }

  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
      }}
    >
      {getInputs(rangeCondition)}
    </Stack>
  )
}

export default RangeInput
